module.exports = __webpack_public_path__ + "static/media/14UNEP11.ec05bbdf.jpg";